import {BaseQueryFn} from '@reduxjs/toolkit/dist/query';
import {Contract} from 'ethers';
import {RootState} from '../app/store';
import {abi as GFTAbi} from '../assets/artifacts/GFTRoot.json';
import SolutionArtifacts from '../assets/artifacts/GGRSolution.json';
import TokenArtifacts from '../assets/artifacts/Stable.json';
import {chainIdToNetworkName} from '../lib/chains';
import walletService from '../services/wallet.service';
import customBaseQuery from './custom.base-query';
import {ContractApiArgs, EApiSourceName, TNetwork} from './types';

export const CONTRACTS = {
  [EApiSourceName.TOKEN]: (contractAddress: string) => new Contract(contractAddress, TokenArtifacts.abi),
  [EApiSourceName.SOLUTION]: (contractAddress: string) => new Contract(contractAddress, SolutionArtifacts.abi),
  [EApiSourceName.GFT_ROOT]: (contractAddress: string) => new Contract(contractAddress, GFTAbi),
};

export const contractBaseQuery: BaseQueryFn<ContractApiArgs, any> = async (args, api, extraOptions) => {
  try {
    if (args.contractName === EApiSourceName.SIGNER) {
      const result = await (walletService.signer as any)[args.method](...(args.callData || []));
      return {
        data: result,
      };
    } else if (args.contractName === EApiSourceName.PROVIDER) {
      const result = await (walletService.provider as any)[args.method](...(args.callData || []));
      return {
        data: result,
      };
    } else {
      const {chainId} = (api.getState() as RootState).wallet;
      const {data: networks, error} = await customBaseQuery(
        {
          url: 'networks',
          method: 'GET',
        },
        {
          ...api,
          type: 'query',
        },
        extraOptions,
      );
      const chainName = chainIdToNetworkName[chainId];
      const contractAddress =
        args.contractAddress || (networks as TNetwork[])?.find(el => el.symbol === chainName)?.gftRootAddress;
      if (!contractAddress) throw new Error(`Unknown address of ${args.contractName}`);
      const result = await CONTRACTS[args.contractName](contractAddress)
        .connect(api.type === 'query' ? walletService.provider! : walletService.signer!)
        [args.method](...(args.callData || []));
      if (api.type === 'mutation') return {data: await result.wait()};
      return {
        data: result,
      };
    }
  } catch (err) {
    console.log('BASE QUERY err', err);
    return {
      error: err,
    };
  }
};
